(function () {
  'use strict';

  var SVG_UP   = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 7L6 1.5L11 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_DOWN = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 6.5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_PREV = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M9 1L1.5 8L9 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M1 1L8.5 8L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var VISIBLE_COUNT = 7;   /* full thumbs shown before clipping */
  var THUMB_GAP     = 6;   /* px — must match CSS gap on .js-thumb-carousel-nav */
  var BREAKPOINT    = 980; /* px — desktop threshold */

  function isDesktop() { return window.innerWidth >= BREAKPOINT; }
  function isEnabledViewport() { return !isDesktop(); } /* mobile + tablet only */

  function makeBtn(extraClass, label, svgStr) {
    var btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'thumb-nav-btn ' + extraClass;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = svgStr;
    btn.style.display = 'none';
    return btn;
  }

  /* ═══════════════════════════════════════════════════════════════
     TEARDOWN
     Reverses everything setup functions add to the DOM so a fresh
     rebuild can happen after a breakpoint crossing.
  ═══════════════════════════════════════════════════════════════ */
  function teardown(thumbsEl) {
    /* Remove any injected buttons */
    thumbsEl.querySelectorAll('.thumb-nav-btn').forEach(function (btn) {
      btn.parentNode && btn.parentNode.removeChild(btn);
    });

    /* Unwrap .thumb-scroll-viewport — move navEl back to wrapper */
    var viewport = thumbsEl.querySelector('.thumb-scroll-viewport');
    if (viewport) {
      var navEl   = viewport.querySelector('.js-thumb-carousel-nav');
      var wrapper = viewport.parentNode;
      if (navEl && wrapper) {
        /* Re-insert navEl where viewport sits, then remove viewport */
        wrapper.insertBefore(navEl, viewport);
      }
      viewport.parentNode && viewport.parentNode.removeChild(viewport);
    }

    /* Reset viewport height that may have been set inline */
    var navEl2 = thumbsEl.querySelector('.js-thumb-carousel-nav');
    if (navEl2) {
      navEl2.style.height  = '';
      navEl2.style.overflow = '';
    }

    /* Clear breakpoint class flags */
    thumbsEl.classList.remove('is-vertical', 'is-horizontal');

    /* Clear all state flags so setup() runs fresh */
    delete thumbsEl._thumbNavDone;
    delete thumbsEl._thumbNavMode;

    /* Disconnect any stored MutationObserver */
    if (thumbsEl._thumbNavObserver) {
      thumbsEl._thumbNavObserver.disconnect();
      delete thumbsEl._thumbNavObserver;
    }
  }

  /* ═══════════════════════════════════════════════════════════════
     VERTICAL (left / right, desktop ≥ 980 px)
  ═══════════════════════════════════════════════════════════════ */
  function setupVerticalScroll(thumbsEl) {
    var navEl = thumbsEl.querySelector('.js-thumb-carousel-nav');
    if (!navEl) return;

    var wrapper  = thumbsEl.querySelector('.thumb-slider-wrapper') || thumbsEl;
    var viewport = document.createElement('div');
    viewport.className = 'thumb-scroll-viewport';
    wrapper.insertBefore(viewport, navEl);
    viewport.appendChild(navEl);

    var upBtn   = makeBtn('thumb-nav-btn--up',   'Previous thumbnails', SVG_UP);
    var downBtn = makeBtn('thumb-nav-btn--down', 'Next thumbnails',     SVG_DOWN);
    wrapper.insertBefore(upBtn, viewport);
    wrapper.appendChild(downBtn);

    function cellHeight() {
      var first = navEl.querySelector('.js-thumb-item:not(.vantage-hidden-media)')
               || navEl.querySelector('.js-thumb-item');
      return first ? first.offsetHeight : 80;
    }

    function visibleCells() {
      return Array.prototype.slice.call(
        navEl.querySelectorAll('.js-thumb-item:not(.vantage-hidden-media)')
      );
    }

    function setViewportHeight(h) {
      h = h || cellHeight();
      var px = h * VISIBLE_COUNT
             + THUMB_GAP * (VISIBLE_COUNT - 1)
             + Math.round(h * 0.5);
      viewport.style.height = px + 'px';
    }

    function refreshArrows() {
      var cells = visibleCells();
      if (cells.length <= VISIBLE_COUNT) {
        upBtn.style.display   = 'none';
        downBtn.style.display = 'none';
        viewport.style.height = 'auto';
        return;
      }
      setViewportHeight();
      var atTop    = viewport.scrollTop <= 2;
      var atBottom = viewport.scrollTop + viewport.clientHeight >= viewport.scrollHeight - 2;
      upBtn.style.display   = atTop    ? 'none' : '';
      downBtn.style.display = atBottom ? 'none' : '';
    }

    function scrollStep(dir) {
      var step = cellHeight() + THUMB_GAP;
      viewport.scrollBy({ top: dir === 'up' ? -step : step, behavior: 'smooth' });
    }

    upBtn.addEventListener('click',     function () { scrollStep('up');   });
    downBtn.addEventListener('click',   function () { scrollStep('down'); });
    viewport.addEventListener('scroll', refreshArrows);

    function ensureSelectedVisible() {
      var sel = navEl.querySelector('.is-nav-selected:not(.vantage-hidden-media)');
      if (!sel) return;
      var top    = sel.offsetTop;
      var bottom = top + sel.offsetHeight;
      var vpTop  = viewport.scrollTop;
      var vpBot  = vpTop + viewport.clientHeight;
      if (top < vpTop) {
        viewport.scrollTo({ top: Math.max(0, top - THUMB_GAP), behavior: 'smooth' });
      } else if (bottom > vpBot) {
        viewport.scrollTo({ top: bottom - viewport.clientHeight + THUMB_GAP, behavior: 'smooth' });
      }
    }

    var obs = null;
    if (window.MutationObserver) {
      obs = new MutationObserver(function () {
        refreshArrows();
        ensureSelectedVisible();
      });
      obs.observe(navEl, {
        attributes: true, attributeFilter: ['class', 'style'], subtree: true
      });
      thumbsEl._thumbNavObserver = obs;
    }

    [300, 800, 1500].forEach(function (t) { setTimeout(refreshArrows, t); });
  }

  /* ═══════════════════════════════════════════════════════════════
     HORIZONTAL (bottom position)
  ═══════════════════════════════════════════════════════════════ */
  function setupHorizontal(thumbsEl) {
    var navEl   = thumbsEl.querySelector('.js-thumb-carousel-nav');
    var prevBtn = makeBtn('thumb-nav-btn--prev', 'Previous thumbnails', SVG_PREV);
    var nextBtn = makeBtn('thumb-nav-btn--next', 'Next thumbnails',     SVG_NEXT);
    thumbsEl.appendChild(prevBtn);
    thumbsEl.appendChild(nextBtn);

    function visibleCells() {
      return Array.prototype.slice.call(thumbsEl.querySelectorAll('.js-thumb-item'))
        .filter(function (el) { return el.style.display !== 'none' && el.offsetParent !== null; });
    }
    function selectedIndex(cells) {
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].classList.contains('is-nav-selected')) return i;
      }
      return 0;
    }
    function refresh() {
      var cells = visibleCells(), n = cells.length;
      if (n < 2) { prevBtn.style.display = nextBtn.style.display = 'none'; return; }
      var idx = selectedIndex(cells);
      prevBtn.style.display = idx > 0     ? '' : 'none';
      nextBtn.style.display = idx < n - 1 ? '' : 'none';
    }
    function goTo(dir) {
      var cells  = visibleCells();
      var target = dir === 'prev' ? cells[selectedIndex(cells) - 1]
                                  : cells[selectedIndex(cells) + 1];
      if (target) target.click();
    }
    prevBtn.addEventListener('click', function () { goTo('prev'); });
    nextBtn.addEventListener('click', function () { goTo('next'); });

    var obs = null;
    if (navEl && window.MutationObserver) {
      obs = new MutationObserver(refresh);
      obs.observe(navEl, {
        attributes: true, attributeFilter: ['class', 'style'], subtree: true
      });
      thumbsEl._thumbNavObserver = obs;
    }
    [300, 800, 1500].forEach(function (t) { setTimeout(refresh, t); });
  }

  /* ═══════════════════════════════════════════════════════════════
     SETUP ROUTER
     mode: 'vertical' | 'horizontal'
     Stores the current mode so resize can detect a real change.
  ═══════════════════════════════════════════════════════════════ */
  function setup(thumbsEl) {
    /* Mobile-only behavior: never change desktop thumbnails */
    if (isDesktop()) {
      teardown(thumbsEl);
      return;
    }

    var pos        = thumbsEl.dataset.thumbnailPosition || 'right';
    var isVertical = pos === 'left' || pos === 'right';

    /* Mobile-only: always use the horizontal prev/next buttons */
    var mode = 'horizontal';

    /* Already set up in this mode — nothing to do */
    if (thumbsEl._thumbNavDone && thumbsEl._thumbNavMode === mode) return;

    /* Different mode from last time — tear everything down first */
    if (thumbsEl._thumbNavDone) teardown(thumbsEl);

    thumbsEl._thumbNavDone = true;
    thumbsEl._thumbNavMode = mode;
    thumbsEl.classList.add('is-horizontal');

    setupHorizontal(thumbsEl);
  }

  /* ═══════════════════════════════════════════════════════════════
     INIT
  ═══════════════════════════════════════════════════════════════ */
  function initAll() {
    document.querySelectorAll('#thumbnails.js-thumb-wrapper').forEach(function (el) {
      if (!isEnabledViewport()) {
        teardown(el);
        return;
      }
      setup(el);
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     RESIZE — only rebuild when crossing the 980 px breakpoint
  ═══════════════════════════════════════════════════════════════ */
  var lastEnabled = isEnabledViewport();
  var resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var nowEnabled = isEnabledViewport();

      /* Enable/disable crossed → full teardown + rebuild */
      if (nowEnabled !== lastEnabled) {
        lastEnabled = nowEnabled;
        document.querySelectorAll('#thumbnails.js-thumb-wrapper').forEach(function (el) {
          teardown(el);
          if (nowEnabled) setup(el);
        });
        return;
      }

      /* Same breakpoint zone — just re-run setup (no-op if mode unchanged) */
      document.querySelectorAll('#thumbnails.js-thumb-wrapper').forEach(function (el) {
        if (nowEnabled) setup(el);
      });
    }, 200);
  });

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  setTimeout(initAll, 1000);

})();